export enum ImportKind {
  EVERNOTE = "EVERNOTE",
  MARKDOWN = "MARKDOWN",
  NOTION = "NOTION",
}
